<template>
    <div id="page">

        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>حضور و غیاب
                    <button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>
            <div class="card card-style mb-2 overflow-visible z-index1000">
                <div class="row m-0 p-3">
                    <div class="col-6 pr-0 pl-1">
                        <div class="btn-group btn-group-sm w-100" role="group" aria-label="Button group with nested dropdown">
                            <v-select class="w-100" dir="rtl" label="title" placeholder="انتخاب کاربر" :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListList" :reduce="p => p.userId" v-model="userId" @option:selected="filterList">
                                <template slot="option">
                                    <div class="d-center">
                                        {{ option.title }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div class="col-6 p-0">
                        <div class="search-box search-color bg-magenta1-light rounded-sm">
                            <i class="fa fa-search pr-3"></i>
                            <input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey" @change="filterList">
                        </div>
                    </div>

                </div>
                <div class="row m-0 px-3 pb-3">
                    <div class="col-12 p-0" v-if="btnAutomaticLoc">
                        <button type="button" v-if="isAutomaticStart==false" class="btn btn-xxs btn-full bg-green1-dark rounded-sm font-900 w-100 font-11" @click.prevent="StartAutomatic">
                            <i class="fa fa-check font-10 ml-2"></i>
                            شروع ثبت موقعیت اتوماتیک
                        </button>
                        <button type="button" v-if="isAutomaticStart==true" class="btn btn-xxs btn-full bg-red1-light rounded-sm font-900 w-100 font-11" @click.prevent="StopAutomatic">
                            <i class="fa fa-times font-10 ml-2"></i>
                            توقف ثبت موقعیت اتوماتیک
                        </button>
                    </div>
                </div>
            </div>



            <div class="card card-style mb-2" @click.prevent="openDetails(task.userPresenceId)" v-for="task in UserPresenceList" :key="task.userPresenceId">
                <div class="list-group list-custom-small list-icon-0">
                    <div class="list-group-div p-2">
                        <div>
                            <i class="fa fa-calendar text-warning"></i>
                            <span class="text-muted d-inline-block text-left ltr">{{task.createDateTime}}</span>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>
                                <i class="fa fa-check color-red1-dark"></i>
                                <span class="font-weight-bold">{{task.title}}</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>
                                <i class="fa fa-user color-green2-light ml-3"></i>
                                <span class="text-muted">{{task.userTitle}}</span>
                            </div>
                            <span @click.stop="showMenu(task.userPresenceId)" width="60px"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="Loading==false && NoMoreData==false && UserPresenceList.length>0 && UserPresenceList.length%20==0">
                <div class="content">
                    <div class="d-flex justify-content-center w-100 py-5">
                        <button class="btn btn-outline-info" @click="getNextPageForUserPresenceList">نمایش بیشتر</button>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="Loading">
                <div class="content">
                    <div class="d-flex justify-content-center w-100 py-5">
                        <div class="spinner-border color-magenta2-dark" role="status"></div>
                    </div>
                </div>
            </div>
            <div class="card card-style" v-if="UserPresenceList.length==0 && Loading==false">
                <div class="content">
                    <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                    <p class="text-center py-3">هیچ موردی یافت نشد.</p>
                </div>
            </div>

        </div>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">
                <router-link to="/CreateUserPresence" class="btn px-3 py-2  rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
                    <i class="fa fa-plus font-14"></i>
                </router-link>
            </div>
        </transition>

        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'EditUserPresence', params: { userPresenceId: selectedWorkId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>

                    <button @click="deleteUserPresence" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>

                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
        <!--<div id="userPresenceHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>

                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-UserPresence.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-UserPresence.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
    </div>
</template>

<script>
    import VueSimpleAlert from 'vue3-simple-alert';
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedWorkId: 0,
                btnAutomaticLoc: false,
                isAutomaticStart: false,
                pageLoaded: false,
                mapLocationObject: null,
                userId: null,
            };
        },
        computed: {
            UserPresenceList() {
                return this.$store.getters.GetUserPresenceList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetUserPresenceNoMoreData;
            },
            localUserListList() {
                return this.$store.getters.GetLocalUserListList;
            },
             UpdateUserPresenceList() {
                return this.$store.getters.GetUpdateUserPresenceList;
            },
        },

        created() {
            console.log(this.NoMoreData);
            this.GetAutoUserLocationStatus();
            this.$store.dispatch("GetLocalUserListListFromServerForMap", { workGroupId: null });
            this.$store.dispatch("GetUserPresenceListFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey,
                userId: this.userId,
                selfUser: true
            });
        },
        methods: {
 
            StartAutomatic() {
                try {
                    this.$http
                        .get("UserPresence/AutoUserLocationStart")
                        .then((data) => {
                            var res = data.data;
                            if (res.isSuccess) {
                                window.location.reload();
                            }
                        });

                } catch (e) {
                    console.log(e);
                }
            },
            StopAutomatic() {
                try {

                    this.$http
                        .get("UserPresence/AutoUserLocationStop")
                        .then((data) => {
                            var res = data.data;
                            if (res.isSuccess) {
                                window.location.reload();
                            }
                        });
                } catch (e) {
                    console.log(e);
                }

            },
            GetAutoUserLocationStatus() {
                this.$http
                    .get("UserPresence/GetAutoUserLocationStatus")
                    .then((data) => {
                        var res = data.data;
                        if (res.isSuccess) {
                            this.isAutomaticStart = true;
                        } else {
                            this.isAutomaticStart = false;
                        }
                        this.btnAutomaticLoc = true;
                    });
            },
            showAddButton() {
                this.pageLoaded = true;
                var x = screen.height;
                var topForAddButton = x - 220 + 'px';
                this.$refs.addBtn.style.top = topForAddButton;
            },
            showMenu(userPresenceId) {
                this.selectedWorkId = userPresenceId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetUserPresenceListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey,
                    userId:this.userId
                });
            },
       
            deleteUserPresence() {
                document.getElementsByClassName('menu-hider')[0].click();
                VueSimpleAlert.confirm("آیا مایل به حذف این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("UserPresence/DeleteUserPresence?id=" + this.selectedWorkId)
                        .then(data => {
                            var res = data.data.toString();
                            if (res==="1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.filterList();

                            }
                            else {
                                this.showErrorMessage(res);
                            }


                        });
                });
            },
            openDetails(userPresenceId) {
                this.$router.push({ name: 'EditUserPresence', params: { userPresenceId: userPresenceId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            getNextPageForUserPresenceList() {

                this.page++;
                console.log(this.page);
                this.$store.dispatch("GetUserPresenceListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
        },
        activated() {
            console.log("mounted");
            this.showAddButton();
            if (this.UpdateUserPresenceList == true) {
                this.page = 1;
                this.filterList();
            }
            // this.getNextPageForUserPresenceList();
        },
        mounted() {
            this.showAddButton();
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        }
    };
</script>
